import { toHexFromId } from '#~/api/utils.js';
import { AutoTrackingWorker } from '#~/workers/auto-tracking/worker.js';
import type { T_Maybe } from '@tryiris-ai/js-types';
import type { Proxy } from './types.js';
import { isElectronApp } from '#~/electron/utils.js';

export class AutoTrackingWorkerManagerImpl {
  workers: Map<string, AutoTrackingWorker> = new Map();

  readonly proxy: Proxy;

  #init: boolean = false;

  constructor(proxy: Proxy) {
    this.proxy = proxy;
  }

  init() {
    if (!isElectronApp('interface')) {
      return;
    }

    if (this.#init) {
      return;
    }

    this.#init = true;

    this.createWorker();
  }

  createWorker(): T_Maybe<AutoTrackingWorker> {
    if (this.workers.size >= 1) {
      return Array.from(this.workers.values())[0];
    }

    const worker = new AutoTrackingWorker(this.proxy);

    this.workers.set(toHexFromId(worker.id)!, worker);
    return worker;
  }
}
